/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:21:50
 * @ Modified by: David Helmick
 * @ Modified time: 2024-06-11 18:01:44
 * @ Description: Card detailing number of bonus properties and how to get more
 */

import React from 'react'
import BonusProperties from '../../Properties/BonusProperties'

import { Card, Box } from '@mui/material'

import { CircularProgressbar } from 'react-circular-progressbar'
import withSession from '@/housefolios-components/Session/withSession'
import useAffiliate from '@/hooks/useAffiliate'

function BonusPropertiesComponent(props) {
  const [{ affiliate, affiliateLoading, urlAffiliate }] =
    useAffiliate({
      memberValue: props?.session?.me?.activeOrg?.member,
    })
  if (
    props.session.me.subscriptionPlan === 'enterprise-affiliate' &&
    props.page === 'launchpad'
  )
    return null
  else
    return (
      <Card variant="outlined"
       
        sx={{ width: '100%', display: 'flex', alignItems: 'center' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', px: '1.5rem', pt: '1.5rem', pb: '0.5rem', }}>
            <Box component="h6" sx={[{ fontWeight: 700, mb: '0.25rem' }, {
              fontSize: "1.265rem !important",
              color: "#070919",
              "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
            }]}>
              Bonus Properties
            </Box>
          </Box>
          <Box sx={{ mx: 'auto' }}>
            <CircularProgressbar value={ props.session.me.activeOrg.propertyCount .bonusProperties> 0 ? 100 : 0 }
              text={props.session.me.activeOrg.propertyCount.bonusProperties.toString()} strokeWidth={8} sx={[{ m: '1rem' }, {
                width: 180,
                "& .CircularProgressbar-path": { stroke: "#368cff" },
                "& .CircularProgressbar-trail": { stroke: "rgba(54, 140, 255, 0.1)" },
                "& .CircularProgressbar-text": { fill: "#368cff" },
                "& .CircularProgressbar-background": { fill: "rgba(54, 140, 255, 0.05)" },
              }]} />
          </Box>
          <Box
            component="p"
            data-hf="muted"
            sx={{
              mb: '1rem',
              color: 'rgba(7, 9, 25, 0.5)',
              textAlign: 'center',
              'html[data-color-mode="dark"] &': {
                color: 'rgba(255, 255, 255, 0.68) !important',
              },
            }}
          >
            Give 10 properties, get 10 properties!
          </Box>
          {!urlAffiliate && (
            <Box sx={{ px: '1.5rem', pb: '1.5rem', pt: '0.5rem' }}>
              <BonusProperties
                session={props.session}
                launchpad={true}
              />
            </Box>
          )}
        </Box>
      </Card>
    )
}

export default withSession(BonusPropertiesComponent)
